import { Billing } from "./Billing";
import { Structure } from "./Structure";
import { UserDTO } from "./User";

export enum PaymentStatus {
  Paid = "paid",
  Pending = "pending",
}

export type Payment = {
  id: string;
  structureId: string;
  amount?: number;
  paymentDate: string;
  period?: string;
  status: PaymentStatus;
  invoiceUrl?: string;
  note?: string;
  isDeposit?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type CreatePaymentDTO = {
  structureId: string;
  amount?: number;
  paymentDate: string;
  period?: string;
  status?: PaymentStatus;
  note?: string;
};

// Struttura arricchita con dati di fatturazione e pagamenti, per la
// pagina di monitoraggio del Superadmin.
export type ManagedStructure = Structure & {
  active: boolean;
  contractUrl?: string;
  hasContract?: boolean;
  annualFee?: number; // costo abbonamento annuale del circolo
  locked?: boolean; // bloccato dal Superadmin: niente gestionale, nascosto in app
  lockMessage?: string | null;
  billing?: Billing;
  parent?: UserDTO;
  payments?: Payment[];
};
